import { LoggerCategoryEnum, LoggerLevelEnum, consoleTransport } from '@nab/nab-x-sdk-browser';
import { getShellVersion } from 'util/shell-version';

let settings;

const baseSettings = {
    transports: {
        [LoggerCategoryEnum.default]: consoleTransport,
        [LoggerCategoryEnum.analytics]: consoleTransport,
        [LoggerCategoryEnum.diagnostic]: consoleTransport,
        [LoggerCategoryEnum.api]: consoleTransport,
        [LoggerCategoryEnum.ui]: consoleTransport
    },
    appName: 'nab-shell',
    autoPostFrequency: 1000,
    consoleLevel: LoggerLevelEnum.log,
    platform: 'nab-x',
};


export function getSettings() {
    if (settings) {
        return settings;
    }
    settings = {
        local: {
            ...baseSettings,
            appVersion: getShellVersion(),
            environment: 'dev'
        },
        dev: {
            ...baseSettings,
            appVersion: getShellVersion(),
            environment: 'dev'
        },
        sit: {
            ...baseSettings,
            appVersion: getShellVersion(),
            environment: 'sit'
        },
    };
    return settings;
}